<template>
  <div class="homomorphic-detail">
    <common-bg-plate>
      <detail-section title="隐私计算任务基本信息">
        <div class="basic-box basic-info">
          <div v-for="(ele, index) in showArr" :key="ele + index" class="item-line basic-info-line">
            <div class="item-label">{{ ele.label }}：</div>
            <div class="item-text">{{ infoObj[ele.value] }}</div>
          </div>
        </div>
      </detail-section>
      <div class="line"></div>
      <detail-section title="数据参与情况">
        <!-- 是否有任务参与方 -->
        <div v-show="hasJoin">
          <el-row>
            <el-col :span="18">
              <el-table :data="joinList">
                <el-table-column type="index" label="序号" width="80" align="center">
                </el-table-column>
                <el-table-column
                  prop="user"
                  label="操作用户"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row['chainUser']['userName'] || $constants.EMPTY }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="org"
                  label="操作组织"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row['chainUser']['orgName'] || $constants.EMPTY }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="org"
                  label="加密数据"
                  align="left"
                  min-width="200"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row['ciphertext'] || $constants.EMPTY }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createdTime"
                  label="提交时间"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{
                      $utils.dateFormat('YYYY-mm-dd HH:MM', scope.row['createdTime'] * 1000) ||
                        $constants.EMPTY
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <div v-show="!hasJoin" class="no-person-box">
          <div class="no-person-tip">暂无参与方</div>
        </div>
        <!-- 判断本人是否参与任务，若没有，显示参与任务按钮 -->
        <!-- <div v-show="isJoin && infoObj.dataStatus !== 'cantJoin'" class="member-info">
          <div class="upload-data-box data-show">
            <div class="upload-title">上传加密数据</div>
            <div class="upload-line">
              <div class="upload-label">专用公钥：</div>
              <div class="upload-text">{{ pubKeyBytes || '--' }}</div>
            </div>
            <div class="upload-line">
              <div class="upload-label">加密数据：</div>
              <div class="upload-text">{{ joinedData.ciphertext || '--' }}</div>
            </div>
            <div class="upload-line last-line">
              <div class="upload-label">提交时间：</div>
              <div class="upload-text">
                {{ joinedData.createdTime ? formatTime(joinedData.createdTime * 1000) : '--' }}
              </div>
            </div>
          </div>
        </div> -->
        <div class="member-info">
          <el-button
            v-show="!isJoin && !showOperate && infoObj.openStatus !== 'closed'"
            type="primary"
            class="join-btn"
            @click="joinTask()"
            >参与任务</el-button
          >
          <el-button
            v-show="infoObj.openStatus == 'canClose'"
            type="primary"
            class="chain-btn"
            @click="closeTask()"
            >关闭任务</el-button
          >
        </div>
        <!--参与任务-->
        <div v-show="showOperate" class="member-info">
          <div class="upload-data-box step-box-wrap">
            <div class="upload-title">上传加密数据</div>
            <div class="upload-step-box">
              <upload-step ref="uploadStepRef"></upload-step>
            </div>
            <div class="upload-line">
              <div class="upload-label">专用公钥：</div>
              <div class="upload-text">{{ pubKeyBytes || '--' }}</div>
            </div>
            <div class="upload-line">
              <div class="upload-label">原始数据：</div>
              <div v-show="step == 0" class="upload-text">
                <el-input v-model="uploadData.data" class="upload-input"></el-input>
              </div>
              <div v-show="step == 1" class="upload-text">
                {{ uploadData.data }}
              </div>
            </div>
            <div v-show="step == 1" class="upload-line">
              <div class="upload-label">加密数据：</div>
              <div class="upload-text">
                {{ uploadData.jiamiData }}
              </div>
            </div>
            <div class="upload-box-btn-wrap">
              <el-button v-show="step == 0" type="primary" @click="handleStep(1)"
                >生成加密数据</el-button
              >
              <el-button
                v-show="step == 1"
                type="primary"
                :disabled="uploadDisabled"
                class="chain-btn"
                @click="goChainData()"
                >上链加密数据</el-button
              >
              <el-button v-show="step == 1" type="primary" @click="handleStep(0)"
                >重新生成加密数据</el-button
              >
            </div>
          </div>
        </div>
      </detail-section>
      <div
        v-show="infoObj.dataStatus == 'decrypted' || infoObj.dataStatus == 'toDecrypt'"
        class="line"
      ></div>
      <detail-section
        v-show="infoObj.dataStatus == 'decrypted' || infoObj.dataStatus == 'toDecrypt'"
        title="隐私计算结果"
      >
        <div class="basic-box">
          <div class="item-line result-btn-wrap">
            <el-button type="primary" @click="handleIncrypt()">解密计算结果</el-button>
          </div>
          <div class="item-line">
            <div class="item-label">计算结果：</div>
            <div class="item-text">
              {{ computingLoading ? computingLoadingText : computeResult }}
            </div>
          </div>
        </div>
      </detail-section>
    </common-bg-plate>
  </div>
</template>
<script>
//import changeChain from './components/changeChain.vue'
import uploadStep from './components/uploadStep.vue'
const Base64 = require('js-base64').Base64
export default {
  components: {
    //changeChain,
    uploadStep
  },
  data() {
    return {
      showArr: [
        { label: '数据名称', value: 'name' },
        { label: '创建时间', value: 'createdTime' },
        { label: '数据描述', value: 'description' },
        { label: '创建用户', value: 'userName' },
        { label: '创建机构', value: 'orgName' }
      ],
      resultArr: [
        { label: '计算结果', value: 'result' },
        { label: '私钥信息', value: 'priKeyBytes' }
      ],
      infoObj: {},
      resultObj: {
        result: '',
        priKeyBytes: ''
      },
      hasJoin: true, // 是否有任务参与方 true有 false无
      isJoin: false, // 本人是否参与任务 true有 false无
      showOperate: false,
      uploadData: {
        publicKey: '',
        data: '',
        jiamiData: ''
      },
      joinedData: {},
      step: 0,
      joinList: [],
      pubKeyBytes: '', //专用公钥
      computeResult: '--',
      computingLoading: false,
      computingLoadingText: '解密中...',
      uploadDisabled: false
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let param = {
        chainId: this.$route.query.chainId,
        taskId: this.$route.query.taskId
      }
      this.$apis.privacy.getTaskDetail(param).then(res => {
        this.infoObj = res.data
        this.infoObj.userName = res.data.createdChainUser.userName
        this.infoObj.orgName = res.data.createdChainUser.orgName
        this.infoObj.createdTime = this.formatTime(res.data.createdTime * 1000)
        this.pubKeyBytes = Base64.decode(res.data.pubKeyBytes)
        this.handleJoinList(res.data)
        if (res.data.dataStatus == 'tojoin') {
          this.isJoin = false
        } else {
          this.isJoin = true
        }
        if (res.data.dataStatus !== 'tojoin') {
          this.handleJoinData(res)
        }
      })
    },
    handleJoinData(res) {
      // 找到自己参与的数据,回显数据详情
      let senderOrgId = JSON.parse(sessionStorage.getItem('cbaas_privacy_chain_client')).orgId
      if (res.data.data1.chainUser.orgId == senderOrgId) {
        this.joinedData = res.data.data1
      }
      if (res.data.data2.chainUser.orgId == senderOrgId) {
        this.joinedData = res.data.data2
      }
      if (res.data.data3.chainUser.orgId == senderOrgId) {
        this.joinedData = res.data.data3
      }
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    handleJoinList(info) {
      if (info.data1.chainUser.userName && info.data1.chainUser.orgId) {
        let index = this.joinList.findIndex(
          ele =>
            ele.chainUser.orgId == info.data1.chainUser.orgId &&
            ele.chainUser.userName == info.data1.chainUser.userName
        )
        if (index == -1) {
          this.joinList.push(info.data1)
        }
      }
      if (info.data2.chainUser.userName && info.data2.chainUser.orgId) {
        let index = this.joinList.findIndex(
          ele =>
            ele.chainUser.orgId == info.data2.chainUser.orgId &&
            ele.chainUser.userName == info.data2.chainUser.userName
        )
        if (index == -1) {
          this.joinList.push(info.data2)
        }
      }
      if (info.data3.chainUser.userName && info.data3.chainUser.orgId) {
        let index = this.joinList.findIndex(
          ele =>
            ele.chainUser.orgId == info.data3.chainUser.orgId &&
            ele.chainUser.userName == info.data3.chainUser.userName
        )
        if (index == -1) {
          this.joinList.push(info.data3)
        }
      }
      this.hasJoin = this.joinList.length > 0
    },
    joinTask() {
      this.showOperate = true
    },
    // 关闭任务
    closeTask() {
      this.$confirm('此操作将关闭该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let param = {
            chainId: this.$route.query.chainId,
            taskId: this.$route.query.taskId
          }
          this.$apis.privacy.closeTasks(param).then(res => {
            this.$message.success('任务关闭成功！')
            this.refresh()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭任务'
          })
        })
    },
    handleStep(num) {
      if (num == 1) {
        if (this.uploadData.data == '') {
          this.$message.warning('请输入原始数据')
          return
        }
        this.step = num
        this.$apis.privacy
          .encryptData({ pub_key: this.pubKeyBytes, text: this.uploadData.data })
          .then(res => {
            if (res.data) {
              this.uploadData.jiamiData = res.data
              this.$refs.uploadStepRef.changeStep(this.step)
            }
          })
      } else {
        this.step = num
        this.uploadData.jiamiData = ''
        this.$refs.uploadStepRef.changeStep(this.step)
      }
    },
    handleIncrypt() {
      let param = {
        chainId: this.$route.query.chainId,
        taskId: this.$route.query.taskId
      }
      this.computingLoading = true
      this.$apis.privacy
        .incryptAvg(param)
        .then(res => {
          if (res.data) {
            this.computeResult = res.data.avg
          }
          this.computingLoading = false
        })
        .catch(err => {
          this.computingLoadingText = '解密计算结果失败'
        })
    },
    goChainData() {
      if (this.uploadData.jiamiData == '') {
        this.$message.warning('未生成加密数据，请稍后')
        return
      }
      this.uploadDisabled = true
      let clientInfo = JSON.parse(sessionStorage.getItem('cbaas_privacy_chain_client'))
      let param = {
        chainId: this.$route.query.chainId,
        taskId: this.$route.query.taskId,
        cipherText: this.uploadData.jiamiData,
        userName: clientInfo.userName,
        orgName: clientInfo.orgName
      }
      this.$apis.privacy
        .saveData(param)
        .then(res => {
          this.$message.success('加密数据上链成功！')
          this.showOperate = false
          this.refresh()
        })
        .catch(err => {
          this.uploadDisabled = false
        })
    },
    refresh() {
      this.getDetail()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'homomorphic-detail',
  (
    --homomorphic-detail-color: #ffffff,
    --homomorphic-detail-line-color: rgba(51, 73, 110, 1),
    --homomorphic-detail-content-bg-color: rgba(58, 69, 109, 1),
    --homomorphic-detail-content-item-label-color: rgba(255, 255, 255, 0.6),
    --homomorphic-detail-content-item-text-color: #fff,
    --homomorphic-detail-content-no-person-text-color: rgba(255, 255, 255, 1),
    --homomorphic-detail-content-upload-box-border-color: rgba(51, 73, 110, 1),
    --homomorphic-detail-content-upload-box-label-color: #fff,
    --homomorphic-detail-content-upload-box-text-color: rgba(255, 255, 255, 0.6),
    --homomorphic-detail-content-upload-box-title-color: #fff,
    --homomorphic-detail-content-upload-data-show-bg: #3a456d
  ),
  (
    --homomorphic-detail-color: #192227,
    --homomorphic-detail-line-color: rgba(235, 235, 235, 1),
    --homomorphic-detail-content-bg-color: rgba(248, 248, 248, 1),
    --homomorphic-detail-content-item-label-color: rgba(90, 105, 115, 1),
    --homomorphic-detail-content-item-text-color: rgba(25, 34, 39, 1),
    --homomorphic-detail-content-no-person-text-color: rgba(90, 105, 115, 1),
    --homomorphic-detail-content-upload-box-border-color: rgba(235, 235, 235, 1),
    --homomorphic-detail-content-upload-box-label-color: rgba(25, 34, 39, 1),
    --homomorphic-detail-content-upload-box-text-color: rgba(90, 105, 115, 1),
    --homomorphic-detail-content-upload-box-title-color: #192227,
    --homomorphic-detail-content-upload-data-show-bg: #f8f8f8
  )
);
.homomorphic-detail {
  @include adaptation(
    (
      --homomorphic-detail-line-width: 1px,
      --homomorphic-detail-content-padding: 20px 16px 10px 16px,
      --homomorphic-detail-content-item-font-size: 14px,
      --homomorphic-detail-content-item-margin-bottom: 10px,
      --homomorphic-detail-content-item-label-width: 70px,
      --homomorphic-detail-content-no-person-tip-margin-bottom: 24px,
      --homomorphic-detail-content-upload-box-padding: 27px 50px,
      --homomorphic-detail-content-upload-box-title-font-size: 16px,
      --homomorphic-detail-content-upload-input-width: 400px,
      --homomorphic-detail-content-result-btn-margin: 0 0 18px,
      --homomorphic-detail-content-font: 12px
    )
  );
  --homomorphic-detail-min-height: var(--base-main-router-body-avaliable-height);
  color: var(--homomorphic-detail-color);
  .common-bg-plate {
    min-height: var(--homomorphic-detail-min-height);
    .line {
      border-bottom: var(--homomorphic-detail-line-width) solid var(--homomorphic-detail-line-color);
    }
    .basic-info {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      .basic-info-line {
        width: 50%;
      }
    }
    .basic-box {
      background: var(--homomorphic-detail-content-bg-color);
      padding: var(--homomorphic-detail-content-padding);
      .item-line {
        display: flex;
        align-items: flex-start;
        font-size: var(--homomorphic-detail-content-font);
        margin-bottom: var(--homomorphic-detail-content-item-margin-bottom);
        .item-label {
          width: var(--homomorphic-detail-content-item-label-width);
          flex-shrink: 0;
          color: var(--homomorphic-detail-content-item-label-color);
        }
        .item-text {
          flex: 1;
          color: var(--homomorphic-detail-content-item-text-color);
        }
      }
      .result-btn-wrap {
        margin: var(--homomorphic-detail-content-result-btn-margin);
      }
    }
    .member-info {
      margin-top: var(--homomorphic-detail-content-item-font-size);
    }
    .no-person-text {
      color: var(--homomorphic-detail-content-no-person-text-color);
      margin-bottom: var(--homomorphic-detail-content-item-margin-bottom);
    }
    .no-person-box {
      .no-person-tip {
        font-size: var(--homomorphic-detail-content-item-font-size);
      }
    }
    .upload-data-box {
      border: var(--homomorphic-detail-line-width) solid
        var(--homomorphic-detail-content-upload-box-border-color);
      padding: var(--homomorphic-detail-content-padding);
      .upload-step-box {
        margin-bottom: var(--homomorphic-detail-content-no-person-tip-margin-bottom);
      }
      .upload-title {
        font-size: var(--homomorphic-detail-content-upload-box-title-font-size);
        color: var(--homomorphic-detail-content-upload-box-title-color);
        margin-bottom: var(--homomorphic-detail-content-no-person-tip-margin-bottom);
      }
      .upload-line {
        display: flex;
        align-items: center;
        font-size: var(--homomorphic-detail-content-item-font-size);
        margin-bottom: var(--homomorphic-detail-content-item-margin-bottom);
        .upload-label {
          width: var(--homomorphic-detail-content-item-label-width);
          color: var(--homomorphic-detail-content-upload-box-text-color);
          font-size: var(--homomorphic-detail-content-font);
        }
        .upload-text {
          color: var(--homomorphic-detail-content-upload-box-label-color);
          font-size: var(--homomorphic-detail-content-font);
        }
        .upload-input {
          width: var(--homomorphic-detail-content-upload-input-width);
        }
      }
      .upload-box-btn-wrap {
        margin-top: var(--homomorphic-detail-content-no-person-tip-margin-bottom);
        margin-bottom: var(--homomorphic-detail-content-item-font-size);
      }
    }
    .step-box-wrap {
      padding-left: var(--homomorphic-detail-content-no-person-tip-margin-bottom);
    }
    .data-show {
      background: var(--homomorphic-detail-content-upload-data-show-bg);
      border: 0;
    }
    .chain-btn {
      margin-left: 0;
    }
    .join-btn {
      margin-right: var(--homomorphic-detail-content-item-margin-bottom);
    }
  }
}
</style>
